<h2 mat-dialog-title class="dialog-header" *ngIf="!isFromDocViewer">
  <div class="header-left">
    <mat-icon class="header-icon">description</mat-icon>
    Line Item / GL Entry
  </div>
  <button type="button" aria-label="Close" (click)="onCancelClick()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<div class="row" [ngStyle]="{ 'padding': !isFromDocViewer ? '20px' : '0' }">
  <div class="mb-3">
    <button pButton type="button" label="Line Item" icon="pi pi-table" (click)="selectTable('LineItemsTable')"
      [ngClass]="getButtonClass('LineItemsTable')">
    </button>
    <button pButton type="button" label="GL Entry" icon="pi pi-table" (click)="selectTable('GLEntryTable')"
      [ngClass]="getButtonClass('GLEntryTable')">
    </button>
  </div>
  <div>
    <p-table 
    [columns]="currentColumns" 
    [value]="currentData" 
    [paginator]="true" 
    [first]="pageNumber" 
    [rows]="rows"
    [totalRecords]="totalRecords" 
    [(selection)]="selectedGlEntryData" 
    [sortField]="sortField" 
    [sortOrder]="sortOrder"
    (onColReorder)="onColumnReordered($event)" 
    [reorderableColumns]="true" 
    sortMode="multiple"
    (onPage)="onPageChange($event)" 
    [loading]="isTableLoading" 
    [loadingIcon]="''" 
    [resizableColumns]="true"
    columnResizeMode="expand" 
    derableColumns="true" 
    [editable]="true">
      <ng-template pTemplate="paginatorright">
        <div class="p-text-right">
          <label for="perPage" class="p-mr-2">Rows per page:</label>
          <select id="perPage" class="p-inputtext" (change)="onRowsChange($event )">
            <option *ngFor="let option of rowsOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col" *ngIf="canEditGLEntryTable" style="text-align: center !important; width: 100px;">
            <button mat-icon-button color="primary" (click)="addNewRow()"
              [disabled]="isAnyRowBeingEdited"><mat-icon>add</mat-icon></button>
          </th>
          <th scope="col" [style.width]="col.width" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
            *ngFor="let col of currentColumns" pReorderableColumn pResizableColumn>
            <div class="top-div">
              <div class="text-section"><span [pSortableColumn]="col.field">{{ col.title }}</span></div>
              <div class="spacer"><p-sortIcon [field]="col.field" /></div>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="currentColumns" let-selected="selected" let-i="rowIndex">
        <tr [pSelectableRow]="rowData" [class.selected-row]="selected" [ngClass]="{ 'p-highlight': isSelected( i) }"
          (click)="onRowClick($event, i)" (mousedown)="onMouseDown($event, i)" (mouseover)="onMouseOver($event, i)"
          (mouseup)="onMouseUp($event)" (keydown)="onRowKeydown($event, i)" (focus)="onRowFocus($event, i)">
          <td *ngIf="canEditGLEntryTable">
            <ng-container *ngIf="editingGLEntryTableRows[i]; else editBtn">
              <button mat-icon-button color="primary" (click)="saveRow( i)"><mat-icon>save</mat-icon></button>
              <button mat-icon-button color="warn" (click)="cancelSave( i )"><mat-icon>cancel</mat-icon></button>
            </ng-container>
            <ng-template #editBtn>
              <button *ngIf="!rowData[i]?.isNew" mat-icon-button color="accent" (click)="editRow( i )"
                [disabled]="isAnyRowBeingEdited"><mat-icon>edit</mat-icon></button>
              <button *ngIf="!rowData[i]?.isNew" mat-icon-button color="accent" (click)="deleteRow( i )"
                [disabled]="isAnyRowBeingEdited"><mat-icon>delete</mat-icon></button>
            </ng-template>
          </td>
          <td *ngFor="let col of currentColumns" [style.min-width]="col.field === 'glAccount' ? '135px' : col.width">
            <ng-container>
              <ng-container *ngIf="editingGLEntryTableRows[i] && col.field !== 'docItemNumber'; else readOnlyCell">
                <ng-container *ngIf="col.field === 'debitCredit'">
                  <p-dropdown [(ngModel)]="rowData[col.field]" [options]="['Debit','Credit']"
                    [placeholder]="'Select ' + col.title" [required]="col.required" appendTo="body" #fieldRef="ngModel">
                  </p-dropdown>
                  <div *ngIf="fieldRef.invalid && (fieldRef.touched  || validationTouched[i])" class="p-error">
                    <span *ngIf="fieldRef.errors?.['required']">{{ col.title }} is required.</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="col.field === 'activityType'">
                  <p-dropdown [(ngModel)]="rowData[col.field]" [options]="activityTypeOptions" optionLabel="activityType" optionValue="activityType"
                    [placeholder]="'Select ' + col.title" [required]="col.required" appendTo="body" #fieldRef="ngModel" (onChange)="onActivityTypeChange(rowData, col.field)">
                  </p-dropdown>
                  <div *ngIf="fieldRef.invalid && (fieldRef.touched  || validationTouched[i])" class="p-error">
                    <span *ngIf="fieldRef.errors?.['required']">{{ col.title }} is required.</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="col.field === 'glAccount' && isCustGLEntryTableDisplay && !isCustNWEGLEntry && !isInFRPenaltyCodingQueue && !isInDEWorkflow">
                  <p-dropdown [(ngModel)]="rowData[col.field]" [options]="glAccountOptions" optionLabel="glAccount" optionValue="glAccount"
                    [placeholder]="'Select ' + col.title" [required]="col.required" appendTo="body" #fieldRef="ngModel" 
                    [disabled]="!rowData.isGlAccountEditable" (ngModelChange)="onCustGLAccountChange(rowData, col.field, i)">
                  </p-dropdown>
                  <div *ngIf="fieldRef.invalid && (fieldRef.touched  || validationTouched[i])" class="p-error">
                    <span *ngIf="fieldRef.errors?.['required']">{{ col.title }} is required.</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="col.field === 'glAccount' && isCustGLEntryTableDisplay && isInFRPenaltyCodingQueue && !isInDEWorkflow">
                  <p-dropdown [(ngModel)]="rowData[col.field]" [options]="glAccountOptions" optionLabel="glAccount" optionValue="glAccount"
                    [placeholder]="'Select ' + col.title" [required]="col.required" appendTo="body" #fieldRef="ngModel" 
                    (ngModelChange)="onCustGLAccountChange(rowData, col.field, i)">
                  </p-dropdown>
                  <div *ngIf="fieldRef.invalid && (fieldRef.touched  || validationTouched[i])" class="p-error">
                    <span *ngIf="fieldRef.errors?.['required']">{{ col.title }} is required.</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="col.type === 'number'">
                  <input [type]="col.field === 'amount' ? 'text' : 'number'" (mousedown)="$event.stopPropagation()" pInputText
                    [placeholder]="'Enter ' + col.title" [(ngModel)]="rowData[col.field]" [required]="col.required"
                    [min]="col.field !== 'amount' ? 1 : null" #fieldRef="ngModel"
                    (ngModelChange)="col.field === 'amount' ? validateAmountCommon($event, fieldRef) : null" />
                  <div *ngIf="fieldRef.invalid && (fieldRef.touched || validationTouched[i])" class="p-error">
                    <span *ngIf="fieldRef.errors?.['required']">{{ col.title }} is required.</span>
                    <span *ngIf="col.field === 'amount' && fieldRef.errors?.['pattern']">Invalid Amount.</span>
                    <span *ngIf="fieldRef.errors?.['min']">Must be greater than 0.</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="isAutoCompleteField(col.type)"> 
                  <p-autoComplete 
                    [(ngModel)]="rowData[col.field]"
                    [suggestions]="getAutoCompleteSuggestions(col.field)" 
                    (completeMethod)="searchAutoComplete($event, col)"
                    (onSelect)="onAutoCompleteSelect($event, rowData, i, col)"
                    (ngModelChange)="onAutoCompleteInputChange($event, i, col)" 
                    [field]="getAutoCompleteDisplayField(col)"
                    [minLength]="3"
                    [dropdown]="true" 
                    [required]="col.required" 
                    [placeholder]="'Enter ' + col.title" 
                    appendTo="body"
                    (mousedown)="$event.stopPropagation()" 
                    #autoCompleteInputRef="ngModel"
                  > 
                    <ng-template let-item pTemplate="item">
                      <div>{{ getAutoCompleteDisplayValue(item, col) }}</div>
                    </ng-template> 
                  </p-autoComplete>
                  <div *ngIf=" autoCompleteInputRef.invalid && (autoCompleteInputRef.touched || validationTouched[i]) " class="p-error">
                    <span *ngIf="autoCompleteInputRef.errors?.['required']"> {{ col.title }} is required. </span> 
                  </div>
                  <div *ngIf=" $any(rowData)[col.field] && $any(rowData)[col.field] !== $any(clonedRows[i])?.[col.field] && !isValidAutoCompleteSelection($any(rowData)[col.field], i, col) && (autoCompleteInputRef.dirty || validationTouched[i])" class="p-error"> 
                    <span> Please select a valid {{ col.title }} from the list. </span> 
                  </div>
                </ng-container>
                <ng-container *ngIf="col.type === 'string' && col.field !== 'debitCredit' && col.field !== 'activityType'  && (col.field !== 'glAccount' || (!isCustGLEntryTableDisplay || (isCustNWEGLEntry && !isInFRPenaltyCodingQueue) || isInDEWorkflow))">
                  <ng-container [ngSwitch]="col.field">
                    <!-- glAccount Autocomplete -->
                    <ng-container *ngSwitchCase="'glAccount' ">
                      <ng-container *ngIf="!isCustGLEntryTableDisplay || (isCustNWEGLEntry && !isInFRPenaltyCodingQueue) || isInDEWorkflow">
                        <p-autoComplete
                          [(ngModel)]="rowData[col.field]"
                          [suggestions]="filteredGlCodes"
                          (completeMethod)="searchGlCodes($event, col.field)"
                          (onSelect)="onGlAccountSelect($event, rowData, i)"
                          (ngModelChange)="onGlAccountInputChange($event, i)"
                          field="glCode"
                          [minLength]="3"
                          [dropdown]="true"
                          [required]="col.required"
                          [placeholder]="'Enter ' + col.title"
                          appendTo="body"
                          (mousedown)="$event.stopPropagation()"
                          #glInputRef="ngModel"
                        >
                          <ng-template let-item pTemplate="item">
                            <div>{{ item.glCode.trim() }} - {{ item.name.trim() }}</div>
                          </ng-template>
                        </p-autoComplete>
                        
                        <!-- Validation for Autocomplete -->
                        <div *ngIf="glInputRef.invalid && (glInputRef.touched || validationTouched[i])" class="p-error">
                          <span *ngIf="glInputRef.errors?.['required']">{{ col.title }} is required.</span>
                        </div>
                        <div *ngIf="rowData[col.field] && rowData[col.field] !== clonedRows[i]?.glAccount && !selectedGLAccounts[i] && (glInputRef.dirty || validationTouched[i])" class="p-error">
                          <span>Please select a valid GL Account from the list.</span>
                        </div>
                      </ng-container>
                    </ng-container>

                    <!-- costcenter Autocomplete -->
                    <ng-container *ngSwitchCase="'costCenter'">
                      <p-autoComplete
                        [(ngModel)]="rowData[col.field]"
                        [suggestions]="filteredCostCenters"
                        (completeMethod)="searchCostCenters($event, col.field)"
                        (onSelect)="onCostCenterSelect($event, rowData, i)"
                        (ngModelChange)="onCostCenterInputChange($event, i)"
                        field="costCenter"
                        [minLength]="3"
                        [dropdown]="true"
                        [required]="col.required"
                        [placeholder]="'Enter ' + col.title"
                        appendTo="body"
                        (mousedown)="$event.stopPropagation()"
                        #costCenterRef="ngModel"
                      >
                        <ng-template let-item pTemplate="item">
                          <div>{{ item.costCenter.trim() }} - {{ item.name.trim() }}</div>
                        </ng-template>
                      </p-autoComplete>
                      <div *ngIf="costCenterRef.invalid && (costCenterRef.touched || validationTouched[i]) && isCustNWEGLEntry" class="p-error">
                        <span *ngIf="costCenterRef.errors?.['required']">{{ col.title }} is required.</span>
                      </div>
                      <div *ngIf="relatedFields.includes(col.field) && isAllEmpty(rowData) && (costCenterRef.touched|| validationTouched[i]) && (!isCustGLEntryTableDisplay || isInDEWorkflow)"
                        class="p-error"
                        style="white-space: nowrap; overflow: visible; text-overflow: clip;"
                        title="At least one of Cost Center, Profit Center, or WBS Element is required.">
                        <span>At least one of Cost Center, Profit Center, or WBS Element is required.</span>
                      </div>
                      <div *ngIf="rowData[col.field] && rowData[col.field] !== clonedRows[i]?.costCenter && !selectedCostCenters[i] && (costCenterRef.dirty || validationTouched[i])" class="p-error">
                        <span>Please select a valid Cost Center from the list.</span>
                      </div>

                    </ng-container>

                    <!-- Regular input (inside ng-template) -->
                    <ng-container *ngSwitchDefault>
                      <input
                        [(ngModel)]="rowData[col.field]"
                        pInputText
                        [required]="col.required"
                        [placeholder]="'Enter ' + col.title"
                        (mousedown)="$event.stopPropagation()"
                        #textInputRef="ngModel"
                        [disabled]="col.field === 'costCenterName' || col.field === 'glAcName' || (!isInDEWorkflow && !isInBENLWorkflow && isCustGLEntryTableDisplay && col.field === 'profitCenter')"
                      />
                      <!-- Validation for regular input -->
                      <div *ngIf="textInputRef.invalid && (textInputRef.touched || validationTouched[i])" class="p-error">
                        <span *ngIf="textInputRef.errors?.['required']">{{ col.title }} is required.</span>
                        <span *ngIf="textInputRef.errors?.['pattern']">Invalid email format.</span>
                      </div>
                      <div *ngIf="relatedFields.includes(col.field) && isAllEmpty(rowData) && (textInputRef.touched|| validationTouched[i]) && (!isCustGLEntryTableDisplay || isInDEWorkflow)"
                        class="p-error"
                        style="white-space: nowrap; overflow: visible; text-overflow: clip;"
                        title="At least one of Cost Center, Profit Center, or WBS Element is required.">
                        <span>At least one of Cost Center, Profit Center, or WBS Element is required.</span>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-template #readOnlyCell>
                <span #tooltipSpan [pTooltip]="isOverflowing ? rowData[col.field] : null" tooltipPosition="top" class="text-ellipsis"
                  (mouseenter)="checkOverflow(tooltipSpan)">
                  {{ rowData[col.field] }}
                </span>
              </ng-template>
              </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="currentColumns.length" class="p-text-center text-muted"
            style="padding: 1rem;text-align: center !important;">
            No data available
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>